<template>
  <div class="login">
    <div class="loginBox">
      <div class="avatarBox">
        <img src="../assets/002.png" />
      </div>
      <el-form ref="loginFormRef" :model="formdata" :rules="rules" label-width="70px" class="loginForm">
        <el-form-item label="用户名" prop="username">
          <el-input v-model="formdata.username" placeholder="请输入您的用户名" prefix-icon="iconfont icon-user"></el-input>
        </el-form-item>
        <el-form-item label="密 码" prop="password">
          <el-input placeholder="请输入您的密码" v-model="formdata.password" prefix-icon="iconfont icon-3702mima"
            type="password"></el-input>
        </el-form-item>
        <el-form-item class="buttons">
          <el-button type="primary" @click="login()">确定</el-button>
          <el-button type="info" @click="resetForm()">重置</el-button>
        </el-form-item>
      </el-form>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      formdata: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          //required 必填
          //message 信息提示
          //trigger 鼠标失去焦点时触发
          { required: true, message: "请输入用户名", trigger: "blur" },
          { min: 3, max: 20, message: "长度在 3 到 20 个字符", trigger: "blur" }
        ],
        password: [{ required: true, message: "请输入密码", trigger: "blur" }]
      }
    };
  },
  methods: {
    resetForm() {
      this.$refs.loginFormRef.resetFields();
    },
     login() {
      this.$refs.loginFormRef.validate( valid => {
        if (!valid) return;

        let formData = new FormData();
        formData.append('account', this.formdata.username);
        formData.append('password', this.formdata.password);
        this.axios.post(this.$Api.userLogin, formData).then( res => {
          if (res.data.status == 500 && res.data.message == "该账号不存在") {
            this.$message.error('该账号不存在');
          }
          if (res.data.status == 500 && res.data.message == "密码错误") {
            this.$message.error('密码错误');
          }

          if (res.data.status == 200) {
            window.sessionStorage.setItem('tocken', res.data.datas.token)
            window.sessionStorage.setItem('account', res.data.datas.account)
            this.$message.success('登录成功');
            this.$router.push('/users')
          }
        })
          .catch(err => {
            this.$message.success('登录失败');
          });

      });
    }
  }
};
</script>

<style scoped>
.login {
  background-color: darkslategray;
  height: 100%;
}

.loginBox {
  width: 450px;
  height: 320px;
  background-color: #ffffff;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 5px;
}

.avatarBox {
  height: 60px;
  width: 60px;
  border: 1px solid #eee;
  border-radius: 50%;
  padding: 5px;
  box-shadow: 0 0 10px #dddddd;
  position: absolute;
  transform: translate(-15%, -15%);
  background-color: #ffffff;
}

.avatarBox img {
  height: 60px;
  width: 60px;
  border-radius: 50%;
  background-color: #eee;
}

.buttons {
  display: flex;
  justify-content: end;
}

.loginForm {
  position: absolute;
  bottom: 30px;
  width: 100%;
  padding: 0 20px;
  box-sizing: border-box;
}
</style>